import React, { useEffect, useRef } from 'react';
import anime from 'animejs';

// Cascade-reveals direct children when scrolled into view, using anime.stagger.
const CascadeGrid = ({ children, className = '', stagger = 80, from = 'first', y = 36 }) => {
    const ref = useRef(null);

    useEffect(() => {
        const root = ref.current;
        if (!root) return;
        const items = root.children;
        Array.from(items).forEach((el) => {
            el.style.opacity = '0';
            el.style.transform = `translateY(${y}px) scale(0.96)`;
        });
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        anime({
                            targets: Array.from(items),
                            opacity: [0, 1],
                            translateY: [y, 0],
                            scale: [0.96, 1],
                            rotateX: [-12, 0],
                            duration: 850,
                            easing: 'easeOutCubic',
                            delay: anime.stagger(stagger, { from }),
                        });
                        io.disconnect();
                    }
                });
            },
            { threshold: 0.15 }
        );
        io.observe(root);
        return () => io.disconnect();
    }, [stagger, from, y]);

    return (
        <div ref={ref} className={className} style={{ perspective: '1000px' }}>
            {children}
        </div>
    );
};

export default CascadeGrid;
